export default __webpack_public_path__ + "static/RR2-logo-3a96282204ff06cffb069ab02d14d679.png";